import { RemoveIcon } from "vega-icons";

import { BackButton } from "@vega-core/components/Buttons/BackButton/BackButton";
import { ThemedIconButton } from "@vega-core/components/Buttons/ThemedIconButton";
import { useModalNavigation } from "@vega-core/hooks/useModalNavigation";
import { m } from "@vega-core/paraglide/messages";

import { HomePage } from "./pages/HomePage";
import { PermissionsTablePage } from "./pages/PermissionsTablePage";
import { RolesReferencePage } from "./pages/RolesReferencePage";
import { ModalRoutes } from "./constants";

type RootProps = {
  initialRoute?: string;
  onClose: VoidFunction;
};

export const Root = ({ initialRoute, onClose }: RootProps) => {
  const { currentComponent, goBack, isHome } = useModalNavigation(
    {
      [ModalRoutes.Home]: (navigate) => <HomePage navigate={navigate} />,
      [ModalRoutes.Roles]: (navigate) => (
        <RolesReferencePage navigate={navigate} />
      ),
      [ModalRoutes.Permissions]: () => <PermissionsTablePage />,
    },
    { initialRoute },
  );

  return (
    <div className="flex flex-col h-full">
      <div className="shrink-0">
        <div className="flex items-center justify-end px-6 pt-4">
          <ThemedIconButton
            dataTestId="permission-help-close"
            icon={<RemoveIcon />}
            onClick={onClose}
            size="medium"
            variant="background"
          />
        </div>
        <div className="px-6 py-4 border-b border-border/primary">
          {isHome ? (
            <h3 className="heading-4">{m.navTitles_help()}</h3>
          ) : (
            <BackButton onClick={goBack} />
          )}
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-6">{currentComponent}</div>
    </div>
  );
};
